import { status } from "@otto-ec/global-resources/debug";

export class Logger {
    /*                          */

    static log(msg: string) {
        if (status().activated) {
            console.log(msg);
        }
    }

    static warn(msg: string) {
        if (console.warn && status().activated) {
            console.warn(msg);
        }
    }

}
